export default (to, from, next) => {
  const token = Boolean(localStorage.getItem('orbital-access-token'));
  if (token) return next();

  return next({ name: 'login' });
};
